import { render } from "./ContentTrans.vue?vue&type=template&id=54fdde5e&scoped=true"
import script from "./ContentTrans.vue?vue&type=script&lang=js"
export * from "./ContentTrans.vue?vue&type=script&lang=js"

import "./ContentTrans.vue?vue&type=style&index=0&id=54fdde5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54fdde5e"

export default script